// This file is auto-generated. Do not edit!

export default [
  {
    symbol: "WETH",
    token: "0x6A023CCd1ff6F2045C3309768eAd9E68F978f6e1",
    usageAsCollateralEnabled: true,
    borrowingEnabled: false,
    stableBorrowRateEnabled: false,
    isActive: true,
    isFrozen: false,
    aTokenAddress: "0xa818F1B57c201E092C4A2017A91815034326Efd1",
    variableDebtTokenAddress: "0x0c0fce05F2314540EcB095bF4D069e5E0ED90fF8",
  },
  {
    symbol: "wstETH",
    token: "0x6C76971f98945AE98dD7d4DFcA8711ebea946eA6",
    usageAsCollateralEnabled: true,
    borrowingEnabled: false,
    stableBorrowRateEnabled: false,
    isActive: true,
    isFrozen: false,
    aTokenAddress: "0x23e4E76D01B2002BE436CE8d6044b0aA2f68B68a",
    variableDebtTokenAddress: "0x9D881f67F20B49243c98f53d2B9E91E39d02Ae09",
  },
  {
    symbol: "GNO",
    token: "0x9C58BAcC331c9aa871AFD802DB6379a98e80CEdb",
    usageAsCollateralEnabled: true,
    borrowingEnabled: true,
    stableBorrowRateEnabled: false,
    isActive: true,
    isFrozen: false,
    aTokenAddress: "0xA1Fa064A85266E2Ca82DEe5C5CcEC84DF445760e",
    variableDebtTokenAddress: "0xBc59E99198DbA71985A66E1713cC89FFEC53f7FC",
  },
  {
    symbol: "USDC",
    token: "0xDDAfbb505ad214D7b80b1f830fcCc89B60fb7A83",
    usageAsCollateralEnabled: true,
    borrowingEnabled: true,
    stableBorrowRateEnabled: false,
    isActive: true,
    isFrozen: true,
    aTokenAddress: "0xc6B7AcA6DE8a6044E0e32d0c841a89244A10D284",
    variableDebtTokenAddress: "0x5F6f7B0a87CA3CF3d0b431Ae03EF3305180BFf4d",
  },
  {
    symbol: "WXDAI",
    token: "0xe91D153E0b41518A2Ce8Dd3D7944Fa863463a97d",
    usageAsCollateralEnabled: true,
    borrowingEnabled: true,
    stableBorrowRateEnabled: false,
    isActive: true,
    isFrozen: false,
    aTokenAddress: "0xd0Dd6cEF72143E22cCED4867eb0d5F2328715533",
    variableDebtTokenAddress: "0x281963D7471eCdC3A2Bd4503e24e89691cfe420D",
  },
  {
    symbol: "EURe",
    token: "0xcB444e90D8198415266c6a2724b7900fb12FC56E",
    usageAsCollateralEnabled: false,
    borrowingEnabled: true,
    stableBorrowRateEnabled: false,
    isActive: true,
    isFrozen: false,
    aTokenAddress: "0xEdBC7449a9b594CA4E053D9737EC5Dc4CbCcBfb2",
    variableDebtTokenAddress: "0xb96404e475f337A7E98e4a541C9b71309BB66c5A",
  },
  {
    symbol: "sDAI",
    token: "0xaf204776c7245bF4147c2612BF6e5972Ee483701",
    usageAsCollateralEnabled: true,
    borrowingEnabled: false,
    stableBorrowRateEnabled: false,
    isActive: true,
    isFrozen: false,
    aTokenAddress: "0x7a5c3860a77a8DC1b225BD46d0fb2ac1C6D191BC",
    variableDebtTokenAddress: "0x8Fe06E1D8Aff42Bf6812CacF7854A2249a00bED7",
  },
  {
    symbol: "USDC.e",
    token: "0x2a22f9c3b484c3629090FeED35F17Ff8F88f76F0",
    usageAsCollateralEnabled: true,
    borrowingEnabled: true,
    stableBorrowRateEnabled: false,
    isActive: true,
    isFrozen: false,
    aTokenAddress: "0xC0333cb85B59a788d8C7CAe5e1Fd6E229A3E5a65",
    variableDebtTokenAddress: "0x37B9Ad6b5DC8Ad977AD716e92F49e9D200e58431",
  },
  {
    symbol: "GHO",
    token: "0xfc421aD3C883Bf9E7C4f42dE845C4e4405799e73",
    usageAsCollateralEnabled: false,
    borrowingEnabled: true,
    stableBorrowRateEnabled: false,
    isActive: true,
    isFrozen: false,
    aTokenAddress: "0x3FdCeC11B4f15C79d483Aedc56F37D302837Cf4d",
    variableDebtTokenAddress: "0x2766EEFE0311Bf7421cC30155b03d210BCE30dF8",
  },
] as const
